// 网易易盾风控

import { Ref, ref } from 'vue';
import { request, storeToRefs, useTenantStore } from '../../stores/index';

// const PRODUCT_ID = 'YD00570022881891';

export function useNEGuardian() {
  const productId: any = ref(null);
  const neg: any = ref(null);
  const error: any = ref(null);
  const token: Ref<string> = ref('');

  const getNegProductID = async () => {
    const { tenantInfo } = storeToRefs(useTenantStore());
    try {
      const response = await request.post(
        '/v1',
        {
          tid: tenantInfo.value.tid,
          option_code: 'YIDUN_PRODUCT_ID',
        },
        {
          headers: {
            cmdId: 370730,
            headerType: 2,
            paramType: 0,
            apiName: 'getSysConfig',
          },
        }
      );
      productId.value = response.data.value;
      return response.data.value;
    } catch (err) {
      console.error('获取产品ID失败:', err);
      error.value = err;
    }
  };

  const initNeg = (productId: string) => {
    console.log('negInstance window', (window as any).createNEGuardian);
    try {
      neg.value = (window as any).createNEGuardian?.({ productId: productId, timeout: 6000 });
      console.log('negInsance neg', neg.value);
    } catch (err) {
      error.value = err;
    }
  };

  const getNegToken = () => {
    return new Promise((resolve, reject) => {
      neg.value
        .getToken()
        .then(result => {
          console.log(' negInsanceget token:', result);
          token.value = result?.token || '';
          resolve(result?.token || '');
          if (result.code === 200) {
            // 正常情况
            console.log('get token:', result.token);
          }
          if (result.code === 201) {
            // 离线模式
            console.log('get token:', result.token);
          }
        })
        .catch(() => {
          resolve('');
        });
    });
  };

  return {
    productId,
    getNegProductID,
    neg,
    error,
    initNeg,
    getNegToken,
    token,
  };
}
